import { useEffect, useRef } from 'react';

function useScrollToBottom(loading = true) {
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    element.scrollTop = element.scrollHeight - element.clientHeight;
  }, [loading]);

  return elementRef;
}

export default useScrollToBottom;
